import { useState } from "react";
import axios from "axios";
import { API } from "@/contexts/AuthContext";

export default function WebsiteAddresses({ draftId, locked, run, onSelect }) {
  const [addresses, setAddresses] = useState([]);
  const [preview, setPreview] = useState(null);
  const [next, setNext] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const load = (older = false) => run("website-addresses", async () => {
    const { data } = await axios.get(
      API + "/website-builder/drafts/" + encodeURIComponent(draftId) + "/publication-addresses",
      { params: older && next ? { after_hostname: next } : {} },
    );
    setAddresses((items) => {
      if (!older) return data.addresses || [];
      const known = new Set(items.map((item) => item.hostname));
      return [...items, ...(data.addresses || []).filter((item) => !known.has(item.hostname))];
    });
    setPreview(data.preview_address || null);
    setNext(data.next_hostname || null); setLoaded(true);
  });

  return <section className="space-y-2 rounded border p-3" aria-label="Website addresses">
    <h4 className="text-sm font-medium">Saved website addresses</h4>
    <p className="text-xs text-slate-500">Publication addresses and this website's reserved preview. Select an address, then check its current hosting and publication status below.</p>
    <button type="button" disabled={locked} onClick={() => load(false)}
      className="rounded border px-3 py-2 text-sm disabled:opacity-50">
      {loaded ? "Refresh saved addresses" : "Show saved addresses"}
    </button>
    {preview && !addresses.some((item) => item.hostname === preview) && <div className="flex flex-wrap items-center justify-between gap-2 rounded border p-2 text-xs">
      <span className="break-all">{preview} · Reserved preview</span>
      <button type="button" disabled={locked} onClick={() => onSelect(preview)}
        className="rounded border px-2 py-1 disabled:opacity-50">Manage address</button>
    </div>}
    {addresses.length > 0 && <ul className="space-y-2">
      {addresses.map((address) => <li key={address.hostname} className="flex flex-wrap items-center justify-between gap-2 rounded border p-2 text-xs">
        <span className="break-all">{address.hostname} · {address.status === "active" ? "Publication active" : "Offline"}</span>
        <button type="button" disabled={locked} onClick={() => onSelect(address.hostname)}
          className="rounded border px-2 py-1 disabled:opacity-50">Manage address</button>
      </li>)}
    </ul>}
    {loaded && !preview && addresses.length === 0 && <p className="text-xs text-slate-500">No publication address or preview reservation saved for this website.</p>}
    {next && <button type="button" disabled={locked} onClick={() => load(true)}
      className="rounded border px-3 py-2 text-sm disabled:opacity-50">Load more addresses</button>}
  </section>;
}
